<script>
export default {};
</script>

<template>
  <div>
    <div>yes here i am, the great pkg component</div>
  </div>
</template>
